import { render, staticRenderFns } from "./update-goods.vue?vue&type=template&id=2b703de2&scoped=true"
import script from "./update-goods.vue?vue&type=script&lang=js"
export * from "./update-goods.vue?vue&type=script&lang=js"
import style0 from "./update-goods.vue?vue&type=style&index=0&id=2b703de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b703de2",
  null
  
)

export default component.exports